
let config = {
    development: {
        apiHost: 'http://localhost:3000',
        assetsHost: "https://virtap.s3.amazonaws.com/test",
        englishWebapp: "http://localhost:8082",
        loginPage: "http://localhost:8000/contratar-assistente-virtual/login.html",
        signupPage: "http://localhost:8000/contratar-assistente-virtual/postar-projeto.html",
        profilePage: "http://localhost:8000/contratar-assistente-virtual/perfil.html"
    },
    production: {
        apiHost: 'https://api.virtap.com.br',
        assetsHost: "https://virtap.s3.amazonaws.com/production",
        englishWebapp: "https://hire.virtap.com.br",
        loginPage: "https://www.virtap.com.br/contratar-assistente-virtual/login",
        signupPage: "https://www.virtap.com.br/contratar-assistente-virtual/postar-projeto",
        profilePage: "https://www.virtap.com.br/contratar-assistente-virtual/perfil"
    }
}

export default config[process.env.NODE_ENV];